/**
 * Ce fel de Centru de comandă primește cineva — din drepturile lui, nu din
 * numele rolului.
 *
 * Se alegea după `role === 'receptie'` și celelalte, deci un rol clonat de
 * clinică („Recepție filiala 2", „Medic rezident") primea centrul general,
 * fără acțiunile și alertele meseriei lui. Regulile de mai jos dau aceeași
 * alegere pentru fiecare rol de sistem (`centre-persona.spec.ts` le ține) și
 * o dau și unui rol nou, după ce poate face.
 */
export type CentrePersona =
  'admin' | 'medic' | 'contabil' | 'hr' | 'receptie' | 'asistent' | 'general';

export function centrePersona(can: (permission: string) => boolean): CentrePersona {
  // Cine conduce: configurează clinica, sau vede banii tuturor și personalul.
  if (can('setari.modifica') || (can('financiar.vede_toti_medicii') && can('personal.vede'))) {
    return 'admin';
  }
  // Cine lucrează la scaun: scrie fișa și vede agenda lui, nu a tuturor.
  if (can('fisa.editeaza') && !can('programari.vede_toti_medicii')) return 'medic';
  // Cine închide ziua fără să lucreze în calendar.
  if (can('incasari.inchide_ziua') && !can('programari.vede')) return 'contabil';
  // Cine se ocupă de oameni fără să vadă pacienți.
  if (can('concedii.aproba') && !can('pacienti.vede_toti') && !can('pacienti.vede_proprii')) {
    return 'hr';
  }
  // Cine face programări pentru toți medicii.
  if (can('programari.vede_toti_medicii') && can('programari.creeaza')) return 'receptie';
  // Cine ține stocul și sterilizarea.
  if (can('sterilizare.gestioneaza') || can('stoc.gestioneaza')) return 'asistent';
  return 'general';
}
